const dataMenuProperties = document.querySelectorAll('[data-properties]')
dataMenuProperties.forEach((menuItem) => {
    const dataProperties = menuItem.dataset.properties
    if (dataProperties.indexOf('}') > -1) {
        const properties = JSON.parse(menuItem.dataset.properties)

        // Dynamically apply each property to the DOM element
        for (const [key, value] of Object.entries(properties)) {
            if (key === 'classList') {
                // If the property is `classList`, add the classes
                if (Array.isArray(value)) {
                    value.forEach((className) => {
                        menuItem.classList += ' ' + className
                    })
                } else {
                    menuItem.classList += ' ' + value
                }
            } else if (key.startsWith('data-')) {
                // If the property is a custom data attribute, set it
                menuItem.setAttribute(key, value)
            } else {
                // Otherwise, set it as a direct property of the element
                if (key !== 'classList') menuItem[key] = value
            }
        }
    }
})
